export const categories = [
  {
    name: 'Shoes',
    slug: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes',
    imageQuery: 'Trendy%20fashion%20sneakers%20and%20casual%20shoes%20displayed%20on%20a%20minimalist%20wooden%20surface%20with%20soft%20natural%20daylight%2C%20clean%20aesthetic%20product%20photography%20with%20warm%20neutral%20background%2C%20editorial%20lifestyle%20shot%20featuring%20modern%20footwear%20styles%20in%20harmonious%20earthy%20tones%2C%20professional%20composition%20with%20gentle%20shadows',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'Hoodies-Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageSeq: 'cat-hoodies',
    imageQuery: 'Cozy%20oversized%20hoodies%20and%20knit%20sweaters%20neatly%20folded%20on%20a%20light%20textured%20fabric%20backdrop%2C%20warm%20neutral%20color%20palette%20with%20cream%20beige%20and%20soft%20gray%20tones%2C%20minimalist%20product%20photography%20with%20diffused%20natural%20window%20light%2C%20clean%20composition%20emphasizing%20texture%20and%20comfort%2C%20editorial%20casual%20fashion%20aesthetic',
  },
  {
    name: 'T-Shirts',
    slug: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageSeq: 'cat-tshirts',
    imageQuery: 'Premium%20cotton%20t-shirts%20in%20various%20neutral%20colors%20artfully%20arranged%20on%20a%20clean%20light%20surface%2C%20minimalist%20flat%20lay%20fashion%20photography%20with%20soft%20morning%20sunlight%2C%20fresh%20and%20modern%20aesthetic%20with%20subtle%20fabric%20texture%20details%2C%20warm%20cream%20background%20with%20gentle%20shadows%2C%20effortless%20everyday%20style%20composition',
  },
  {
    name: 'Jackets',
    slug: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageSeq: 'cat-jackets',
    imageQuery: 'Stylish%20modern%20jackets%20including%20bomber%20and%20denim%20styles%20hanging%20on%20a%20minimalist%20wooden%20rack%2C%20soft%20natural%20lighting%20from%20large%20window%20creating%20gentle%20highlights%2C%20clean%20contemporary%20fashion%20photography%20with%20warm%20earthy%20background%20tones%2C%20editorial%20product%20display%20with%20thoughtful%20composition%20and%20texture%20emphasis',
  },
  {
    name: 'Pants/Shorts',
    slug: 'Pants-Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageSeq: 'cat-pants',
    imageQuery: 'Casual%20trousers%20and%20tailored%20shorts%20in%20neutral%20earth%20tones%20neatly%20displayed%20on%20a%20minimalist%20clothing%20rail%2C%20soft%20ambient%20studio%20lighting%20with%20clean%20shadows%2C%20modern%20fashion%20product%20photography%20with%20warm%20beige%20backdrop%2C%20refined%20everyday%20wardrobe%20essentials%20composition%20emphasizing%20fabric%20drape%20and%20versatility',
  },
  {
    name: 'Headwear',
    slug: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageSeq: 'cat-headwear',
    imageQuery: 'Trendy%20baseball%20caps%20and%20beanies%20in%20neutral%20colors%20arranged%20on%20a%20light%20wooden%20surface%2C%20minimalist%20accessories%20photography%20with%20soft%20natural%20daylight%2C%20clean%20composition%20with%20warm%20cream%20background%20and%20subtle%20textures%2C%20modern%20streetwear%20aesthetic%20capturing%20casual%20style%20essentials%2C%20editorial%20product%20display%20with%20gentle%20shadows',
  },
  {
    name: 'Sets',
    slug: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageSeq: 'cat-sets',
    imageQuery: 'Coordinated%20fashion%20sets%20with%20matching%20tops%20and%20bottoms%20displayed%20on%20minimalist%20mannequins%2C%20soft%20studio%20lighting%20with%20clean%20warm%20background%2C%20modern%20lifestyle%20product%20photography%20showcasing%20complete%20outfit%20combinations%20in%20harmonious%20neutral%20tones%2C%20editorial%20fashion%20display%20with%20elegant%20composition%20and%20gentle%20contrast',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'Underwear-Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageSeq: 'cat-underwear',
    imageQuery: 'Soft%20cotton%20underwear%20essentials%20in%20neutral%20tones%20neatly%20folded%20on%20a%20clean%20light%20linen%20fabric%20surface%2C%20minimalist%20intimate%20apparel%20photography%20with%20diffused%20natural%20light%2C%20gentle%20warm%20white%20backdrop%20creating%20fresh%20clean%20aesthetic%2C%20understated%20product%20display%20emphasizing%20comfort%20and%20simplicity',
  },
  {
    name: 'Jersey',
    slug: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageSeq: 'cat-jersey',
    imageQuery: 'Athletic%20sports%20jerseys%20in%20vibrant%20yet%20earthy%20colors%20displayed%20on%20a%20minimalist%20wooden%20hanger%2C%20soft%20studio%20lighting%20highlighting%20fabric%20texture%20and%20design%20details%2C%20clean%20sportswear%20product%20photography%20with%20warm%20neutral%20background%2C%20modern%20athletic%20aesthetic%20capturing%20dynamic%20energy%20with%20elegant%20simplicity',
  },
  {
    name: 'Accessories',
    slug: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageSeq: 'cat-accessories',
    imageQuery: 'Fashion%20accessories%20including%20watches%20bracelets%20and%20sunglasses%20artfully%20arranged%20on%20a%20light%20marble%20surface%2C%20minimalist%20product%20photography%20with%20soft%20natural%20window%20light%2C%20warm%20cream%20background%20with%20delicate%20shadows%2C%20clean%20elegant%20composition%20showcasing%20modern%20accessories%20in%20harmonious%20metallic%20and%20neutral%20tones',
  },
  {
    name: 'Bags',
    slug: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageSeq: 'cat-bags',
    imageQuery: 'Stylish%20modern%20bags%20including%20backpacks%20and%20tote%20bags%20displayed%20on%20a%20minimalist%20wooden%20shelf%2C%20soft%20natural%20daylight%20illuminating%20leather%20and%20fabric%20textures%2C%20clean%20fashion%20product%20photography%20with%20warm%20neutral%20backdrop%2C%20contemporary%20accessories%20aesthetic%20with%20thoughtful%20composition%20and%20gentle%20highlights',
  },
  {
    name: 'Belts',
    slug: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageSeq: 'cat-belts',
    imageQuery: 'Premium%20leather%20and%20fabric%20belts%20in%20neutral%20tones%20elegantly%20coiled%20on%20a%20light%20textured%20surface%2C%20minimalist%20accessories%20photography%20with%20soft%20directional%20lighting%2C%20warm%20cream%20background%20creating%20clean%20sophisticated%20look%2C%20editorial%20product%20display%20emphasizing%20craftsmanship%20and%20material%20quality%2C%20refined%20composition',
  },
  {
    name: 'Perfumes',
    slug: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageSeq: 'cat-perfumes',
    imageQuery: 'Elegant%20perfume%20bottles%20with%20minimalist%20glass%20designs%20arranged%20on%20a%20light%20marble%20surface%2C%20soft%20natural%20window%20light%20creating%20delicate%20reflections%20and%20highlights%2C%20luxury%20fragrance%20product%20photography%20with%20warm%20neutral%20backdrop%2C%20clean%20sophisticated%20composition%20with%20fresh%20floral%20accents%2C%20editorial%20beauty%20aesthetic',
  },
  {
    name: 'OtherStuff',
    slug: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageSeq: 'cat-other',
    imageQuery: 'Diverse%20lifestyle%20products%20and%20miscellaneous%20fashion%20items%20creatively%20arranged%20on%20a%20clean%20light%20surface%2C%20minimalist%20product%20flat%20lay%20photography%20with%20soft%20natural%20daylight%2C%20warm%20cream%20background%20with%20gentle%20texture%2C%20eclectic%20yet%20harmonious%20composition%20featuring%20various%20everyday%20essentials%20in%20neutral%20earthy%20tones',
  },
];